import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { articles, statsData, categories } from '@/mocks/articles';

function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20scene%20of%20entertainment%20award%20ceremony%20with%20soft%20bokeh%20light%20effects%2C%20dramatic%20spotlight%20beams%20cutting%20through%20darkness%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20blurred%20paparazzi%20flash%20effects%2C%20elegant%20yet%20mysterious%20atmosphere%2C%20dark%20atmospheric%20background%20with%20light%20leaks%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20moody%20lighting%2C%20artistic%20grain%20texture%2C%2016:9%20cinematic%20composition&width=1920&height=1080&seq=home-hero-01&orientation=landscape"
        alt="爆瓜网 - 吃瓜黑料实时更新"
        title="爆瓜网首页背景 - 娱乐八卦资讯平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>

      <div className="relative z-10 h-full w-full flex items-end pb-12 md:pb-20">
        <div className="px-4 md:px-6 w-full">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-xs md:text-sm text-white/90 font-label mb-4 md:mb-6">
                今日顶流大瓜
              </span>
              <h1 className="text-3xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight tracking-tight">
                全网吃瓜
                <br />
                实时爆料
              </h1>
              <p className="mt-4 md:mt-6 text-sm md:text-base text-white/70 max-w-md font-body leading-relaxed">
                每日更新网红大瓜、明星黑料、博主翻车现场，你的随身吃瓜神器
              </p>
              <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href="#hot-gua"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-fill w-4 h-4 flex items-center justify-center"></i>
                  立即吃瓜
                </a>
                <a
                  href="#download"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
                  APP下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}

function HotGuaGrid() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section id="hot-gua" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-10 md:mb-14">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                全网热搜瓜
              </h2>
              <p className="mt-2 text-sm md:text-base text-foreground-600 font-body">
                最新鲜的爆料，最劲爆的猛料，每日实时更新
              </p>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 text-xs font-medium rounded-full bg-background-100 text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer ${
                  index === 0 ? 'lg:col-span-1 lg:row-span-1' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[16/10]' : 'aspect-[4/3]'}`}>
                  <img
                    src={article.thumbnail}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={index < 3 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-[10px] font-semibold rounded-full bg-primary-500 text-white">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 ${
                    index === 0 ? 'text-base md:text-lg' : 'text-sm md:text-base'
                  }`}>
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 font-body line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 md:mt-4 flex items-center gap-3 text-xs text-foreground-500 font-label">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.viewCount >= 10000
                        ? `${(article.viewCount / 10000).toFixed(0)}万`
                        : article.viewCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.commentCount >= 10000
                        ? `${(article.commentCount / 10000).toFixed(0)}万`
                        : article.commentCount}
                    </span>
                    <span className="ml-auto text-foreground-400">{article.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/category/star-scandal"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-700 hover:text-foreground-950 transition-colors duration-200 cursor-pointer"
            >
              查看更多爆料 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col items-center text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white text-foreground-800 text-xs font-semibold font-label mb-4">
              爆瓜数据
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              千万瓜友的选择
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600 font-body">
              全网吃瓜中枢，每日为百万用户提供最新爆料
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16">
            <div className="text-center">
              <i className="ri-flashlight-line text-xl md:text-2xl text-secondary-600 w-6 h-6 mx-auto flex items-center justify-center mb-3"></i>
              <p className="text-xs md:text-sm text-foreground-700 font-body">实时推送</p>
            </div>
            <div className="text-center">
              <i className="ri-shield-check-line text-xl md:text-2xl text-secondary-600 w-6 h-6 mx-auto flex items-center justify-center mb-3"></i>
              <p className="text-xs md:text-sm text-foreground-700 font-body">匿名爆料</p>
            </div>
            <div className="text-center">
              <i className="ri-vidicon-line text-xl md:text-2xl text-secondary-600 w-6 h-6 mx-auto flex items-center justify-center mb-3"></i>
              <p className="text-xs md:text-sm text-foreground-700 font-body">视频实锤</p>
            </div>
            <div className="text-center">
              <i className="ri-global-line text-xl md:text-2xl text-secondary-600 w-6 h-6 mx-auto flex items-center justify-center mb-3"></i>
              <p className="text-xs md:text-sm text-foreground-700 font-body">全网聚合</p>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {statsData.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-3xl md:text-5xl font-heading font-black text-foreground-950 tracking-tight">
                  {stat.value}
                </p>
                <p className="mt-1 text-sm font-semibold text-foreground-800">{stat.label}</p>
                <p className="mt-1 text-xs text-foreground-600 font-body">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section id="download" className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-accent-50">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20entertainment%20news%20app%20interface%20with%20dark%20theme%2C%20trending%20gossip%20feed%20on%20screen%2C%20clean%20minimal%20design%2C%20warm%20ambient%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20elegant%20composition%2C%20lifestyle%20aesthetic&width=960&height=800&seq=home-cta-01&orientation=portrait"
          alt="爆瓜网APP界面预览"
          title="爆瓜网APP - 吃瓜黑料一手掌握"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-4 left-4 md:top-8 md:left-8">
          <span className="text-xs md:text-sm text-foreground-600 font-label">移动端</span>
        </div>
        <div className="absolute bottom-6 left-4 md:bottom-10 md:left-8">
          <h3 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 leading-tight">
            随时随地
            <br />
            吃瓜不停
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 flex flex-col items-center justify-center px-4 md:px-6 py-12 md:py-0 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            下载爆瓜网APP
          </h2>
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mt-1">
            第一时间获取最新爆料
          </h3>
          <p className="mt-4 text-sm md:text-base text-foreground-600 font-body leading-relaxed">
            推送通知实时提醒，热门大瓜不再错过。支持iOS和Android双平台下载，海量内容免费浏览。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-apple-fill w-4 h-4 flex items-center justify-center"></i>
              iOS 下载
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-800 font-semibold text-sm rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-android-fill w-4 h-4 flex items-center justify-center"></i>
              Android 下载
            </a>
          </div>
          <p className="mt-4 text-xs text-foreground-500 font-body">
            扫码下载或点击上方按钮，即可体验爆瓜网APP
          </p>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="爆瓜网app下载与最新地址发布页，承接网红大瓜、明星黑料、博主反差视频等实时爆料内容，是每日吃瓜追更的首选站点入口。"
        keywords="爆瓜网,爆瓜网app,爆瓜网下载,爆瓜网最新地址,爆瓜网入口,吃瓜,爆料,黑料,网红,反差视频,塌房现场"
        canonicalUrl="http://51yingba.cn/"
        ogType="website"
        schemaData={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '爆瓜网首页',
            description: '爆瓜网 - 吃瓜黑料实时更新平台首页',
            url: 'http://51yingba.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '爆瓜网',
              url: 'http://51yingba.cn/',
            },
          },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <HotGuaGrid />
          <StatsSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}